function isDynamicOption(option?: string): boolean {
    return (option && typeof option === 'string' && option.trim().startsWith('>')) || false;
}

export { isDynamicOption };
